// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-4, 16px);
  padding: var(--space-6, 24px);
}

.loading-spinner-container.small {
  padding: var(--space-4, 16px);
  gap: var(--space-3, 12px);
}

.loading-spinner-container.large {
  padding: var(--space-7, 32px);
  gap: var(--space-5, 20px);
}

.loading-spinner-container--fullscreen {
  min-height: 100vh;
  width: 100%;
  padding: var(--space-8, 40px);
  background-color: var(--color-canvas, var(--color-light-gray));
  box-sizing: border-box;
}

.loading-spinner-mark {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.loading-spinner-container.small .loading-spinner-mark {
  width: 28px;
  height: 28px;
}

.loading-spinner-container.large .loading-spinner-mark {
  width: 52px;
  height: 52px;
}

.loading-spinner-ring {
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2.5px solid var(--color-light-green, #d4e8ed);
  border-top-color: var(--color-primary-green, #2c6975);
  animation: loading-spin 0.75s linear infinite;
}

.loading-spinner-container.small .loading-spinner-ring {
  border-width: 2px;
}

.loading-spinner-container.large .loading-spinner-ring {
  border-width: 3px;
}

@keyframes loading-spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin: 0;
  font-family: 'Urbanist', sans-serif;
  font-size: 14px;
  line-height: 1.4;
  color: var(--color-dark-gray);
  text-align: center;
  font-weight: 500;
  max-width: 280px;
}

.loading-spinner-container.small .loading-text {
  font-size: 12px;
}

.loading-spinner-container.large .loading-text {
  font-size: 15px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (prefers-reduced-motion: reduce) {
  .loading-spinner-ring {
    animation-duration: 1.4s;
  }
}

@media (max-width: 768px) {
  .loading-spinner-container {
    padding: var(--space-5, 20px);
    gap: var(--space-3, 12px);
  }

  .loading-spinner-container--fullscreen {
    padding: var(--space-6, 24px);
  }

  .loading-text {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoadingSpinner/LoadingSpinner.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".loading-spinner-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-4, 16px);\n  padding: var(--space-6, 24px);\n}\n\n.loading-spinner-container.small {\n  padding: var(--space-4, 16px);\n  gap: var(--space-3, 12px);\n}\n\n.loading-spinner-container.large {\n  padding: var(--space-7, 32px);\n  gap: var(--space-5, 20px);\n}\n\n.loading-spinner-container--fullscreen {\n  min-height: 100vh;\n  width: 100%;\n  padding: var(--space-8, 40px);\n  background-color: var(--color-canvas, var(--color-light-gray));\n  box-sizing: border-box;\n}\n\n.loading-spinner-mark {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n}\n\n.loading-spinner-container.small .loading-spinner-mark {\n  width: 28px;\n  height: 28px;\n}\n\n.loading-spinner-container.large .loading-spinner-mark {\n  width: 52px;\n  height: 52px;\n}\n\n.loading-spinner-ring {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 2.5px solid var(--color-light-green, #d4e8ed);\n  border-top-color: var(--color-primary-green, #2c6975);\n  animation: loading-spin 0.75s linear infinite;\n}\n\n.loading-spinner-container.small .loading-spinner-ring {\n  border-width: 2px;\n}\n\n.loading-spinner-container.large .loading-spinner-ring {\n  border-width: 3px;\n}\n\n@keyframes loading-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-text {\n  margin: 0;\n  font-family: 'Urbanist', sans-serif;\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--color-dark-gray);\n  text-align: center;\n  font-weight: 500;\n  max-width: 280px;\n}\n\n.loading-spinner-container.small .loading-text {\n  font-size: 12px;\n}\n\n.loading-spinner-container.large .loading-text {\n  font-size: 15px;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .loading-spinner-ring {\n    animation-duration: 1.4s;\n  }\n}\n\n@media (max-width: 768px) {\n  .loading-spinner-container {\n    padding: var(--space-5, 20px);\n    gap: var(--space-3, 12px);\n  }\n\n  .loading-spinner-container--fullscreen {\n    padding: var(--space-6, 24px);\n  }\n\n  .loading-text {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
